export default function DeleteAssetConfirmDialogController(
  $q,
  $rootScope,
  $scope,
  alerts,
  assetDataService,
  loaderService,
  ssDialogService
) {
  const vm = this;

  vm.handleCloseDialog = _handleCloseDialog;
  vm.handleConfirmDelete = _handleConfirmDelete;

  /** *********************************************
   * Event Handlers
   */

  function _handleCloseDialog($event) {
    _closeDialog($event);
  }

  function _handleConfirmDelete($event) {
    loaderService.showViewLoader = true;
    return assetDataService.deleteAsset(vm.asset.customerAssetId)
      .then(() => {
        alerts.success(`The asset "${vm.asset.name}" was successfully deleted.`);
        if (vm.updateCallBack) {
          vm.updateCallBack();
        }
        _closeDialog($event);
      }).catch(() => {
        alerts.error('An error occurred while deleting the control.');
      }).finally(() => {
        loaderService.showViewLoader = false;
      });
  }

  /** *********************************************
   * Private Functions
   */

  function _closeDialog() {
    return ssDialogService.hide(ssDialogService.dialogs.assetAdmin.deleteAssetDialog);
  }
}

DeleteAssetConfirmDialogController.$inject = [
  '$q',
  '$rootScope',
  '$scope',
  'alerts',
  'assetDataService',
  'loaderService',
  'ssDialogService'
];
